const en = {
  profile: {
    title: 'Profile',
    email: 'Email',
    pseudo: 'Pseudo',
    language: 'Language',
    password: 'Password',
    editPseudo: 'Edit Pseudo',
    editThumbnail: 'Edit Thumbnail',
    updatePassword: 'Change Password',
    editEmail: 'Change Email',
    editLanguage: 'Change Language',
    pseudoMandatory: 'Please choose a display name. This is how other users will see you.',
    saveName: 'Save Name',
    savePhoto: 'Save Photo',
    savePassword: 'Update Password',
    saveLanguage: 'Save Language',
    saveEmail: 'Update Email',
    nameUpdated: 'Name successfully updated',
    passwordUpdated: 'Password successfully updated',
    languageUpdated: 'Language successfully updated',
    updateEmail: 'Change Email',
    verificationEmail: 'Verification Email',
    verificationEmailSent: 'A verification email has been sent to both your',
    newAndOld: 'new and old',
    emailAddresses: 'email addresses. Please',
    clickBothLinks: 'click on both links.',
    ok: 'Ok',
    basic: 'Basic',
    upgradePlan: 'Upgrade Plan',
    seePayments: 'See Payments',
    cancelSubscription: 'Cancel Subscription',
    goTo: 'Go to',
    fullNamePlaceholder: 'Full Name',
    emailPlaceholder: 'Email',
    uploadImage: 'Upload an image',
    sharingNotAvailable: 'The sharing features are not available on the free plan. Upgrade to the Pro or Enterprise plan to access them.',
    orgExists: 'An organization already exists for your email domain.',
  },
  common: {
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    noResults: 'No results',
    confirm: 'Confirm',
    back: 'Back',
    select: 'Select',
    send: 'Send',
    update: 'Update',
    rename: 'Rename',
    remove: 'Remove',
    ok: 'Ok',
    create: 'Create',
    convert: 'Convert',
    seeMore: 'See more',
    seeLess: 'See less',
    me: 'Me',
    owner: 'Owner',
    invited: 'Invited',
    contributor: 'Contributor',
    viewer: 'Viewer',
    requested: 'Requested',
    revokeAccess: 'Revoke Access',
    leave: 'Leave',
    present: 'Present',
    namePlaceholder: 'Name',
    linkCopied: 'Link Copied',
    modified: 'Modified',
    approve: 'Approve',
    decline: 'Decline',
    error: 'Error',
    success: 'Success',
  },
  auth: {
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    updatePassword: 'Change Password',
    signInWithGoogle: 'Sign In with Google',
    signUpWithGoogle: 'Sign Up with Google',
    newHereSignUp: 'New here? Sign up',
    goBackToSignIn: 'Back to Sign In',
    goBackSignIn: 'Back to Sign In',
    invalidEmail: 'invalid email address',
    passwordMinLength: 'Password should have at least 6 characters',
    confirmPassword: 'Confirm Password',
    passwordsDoNotMatch: 'Your passwords do not match',
    createAccount: 'Create Account',
    termsText: 'By clicking on "Create Account" or "Sign Up with Google", you agree to the Bibliona Terms of Use and Privacy Policy. We use cookies to enhance your experience on our site.',
    emailConfirmed: 'Email successfully confirmed!',
    resetPasswordDesc: 'We\'ll send you a link to reset your password.',
    linkSentTo: 'A link has been sent to',
    signUpDesc: 'Check your inbox for a confirmation link.',
    newPassword: 'New Password',
    needSignInBeforeUpgrade: 'Sign in to upgrade your plan.',
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    info: 'Info',
    optimizedForLargerScreen: 'The experience is optimized for larger screens.',
    passwordConfirmationMinLength: 'Password confirmation should have at least 6 characters',
    openInBrowserForGoogleSignIn: 'Google Sign-In is blocked in this in-app browser. Please open this page in your browser.',
    googleInAppBrowserBlocked: 'Google Sign-In is not available in this app browser.',
    openInBrowser: 'Open in browser',
  },
  home: {
    welcome: 'Welcome!',
    welcomeDesc: 'New here? Watch this quick intro to get started with Bibliona.',
    onboardingTitle: 'Get started',
    onboardingDesc: 'Complete these steps to create your first complete workflow.',
    onboardingStepProductTitle: 'Create a product',
    onboardingStepProductDesc: 'Create your first product in your workspace.',
    onboardingStepPersonaTitle: 'Create a persona',
    onboardingStepPersonaDesc: 'Create a persona to describe your target user.',
    onboardingStepExperienceTitle: 'Create an experience in this persona and add to this experience the product created in the previous step',
    onboardingStepExperienceDesc: 'Add an experience to a persona and link at least one product.',
    onboardingStepTwoInsightsTitle: 'Add two insights (one improvement feedback and one Negative Feedback) to the experience previously created.',
    onboardingStepTwoInsightsDesc: 'Create one Improvement Feedback insight and one Negative Feedback insight in this experience.',
    onboardingStepArchiveInsightTitle: 'Archive one insight',
    onboardingStepArchiveInsightDesc: 'Archive one of your insights to validate insight lifecycle management.',
    continueStep: 'Continue',
    resumeOnboarding: 'Resume onboarding',
    onboardingCurrentStepPrefix: 'Onboarding step',
    onboardingSkip: 'Skip',
    onboardingSkipConfirmTitle: 'Are you sure to skip onboarding?',
    onboardingSkipConfirmMessage: 'Onboarding will no longer be displayed.',
    onboardingCompletedTitle: 'Congratulations, you finished onboarding!',
    onboardingCompletedMessage: 'You are ready to build your library of personas and products.',
    onboardingGoToHome: 'Go to homepage',
    title: 'Home',
    personas: 'Personas',
    products: 'Products',
    sharedExperiences: 'Shared Experiences',
    createPersona: 'Create Persona',
    createProduct: 'Create Product',
    createSharedExperience: 'Create Shared Experience',
    noPersonas: 'No personas yet. Create your first one!',
    noProducts: 'No products yet. Create your first one!',
    noSharedExperiences: 'No shared experiences yet.',
  },
  nav: {
    home: 'Home',
    personas: 'Personas',
    products: 'Products',
    sharedExperiences: 'Shared Experiences',
    hideMenu: 'Hide Menu',
    openMenu: 'Open Menu',
    profile: 'Profile',
    signOut: 'Sign Out',
    giveFeedback: 'Share Feedback',
    support: 'Support',
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
  },
  search: {
    placeholder: 'Search in Bibliona\u2026',
    all: 'All',
    persona: 'Persona',
    product: 'Product',
    experienceGroup: 'Experience/Group',
    insight: 'Insight',
    sharedExperience: 'Shared Experience',
    noResultFound: 'No results found',
    experience: 'Experience',
  },
  persona: {
    title: 'Persona',
    experiences: 'Experiences',
    products: 'Products',
    sharedExperiences: 'Shared Experiences',
    members: 'Members',
    noExperiences: 'No experiences yet. Start by adding one.',
    noProducts: 'No products yet.',
    noSharedExperiences: 'No shared experiences yet.',
    addExperience: 'Add Experience',
    addProduct: 'Add Product',
    addSharedExperience: 'Add Shared Experience',
    newSharedExperience: 'New Shared Experience',
    selectSharedExperience: 'Select a shared experience',
    deletePersona: 'Delete Persona',
    editName: 'Edit Name',
    editPersona: 'Edit Persona',
    removeFromPersona: 'Remove from Persona',
    createNewSharedExperience: '+ Create New Shared Experience',
    pleaseSelectSharedExperience: 'Please select a shared experience',
    sharedExperiencesName: 'Shared Experience Name',
    enterSharedExperiencesName: 'Enter shared experience name',
    failedToAdd: 'Failed to add shared experience',
    failedToCreate: 'Failed to create shared experience',
    newPersona: 'New Persona',
    onboardingNameLabel: 'Persona',
    onboardingNameDescription: 'A persona is an imaginary user profile used to understand user needs, goals, and behaviors.',
    confirmDeletePersona: 'Are you sure to delete this persona?',
    addValueProposition: 'Add Value Proposition',
    addProductTypes: 'Add Product Types',
    addMainFeatures: 'Add Main Features',
    addUsefulLinks: 'Add Useful Links',
    addBio: 'Add Bio',
    addQuote: 'Add Quote',
    addAttributes: 'Add Attributes',
    addPersonaToProduct: 'Add Persona to Product',
    removeProduct: 'Remove Product',
    confirmRemoveProduct: 'Are you sure to remove this product from the persona?',
    removePersona: 'Remove Persona',
    confirmRemovePersona: 'Are you sure to remove this persona?',
    age: 'Age',
    job: 'Job',
    education: 'Education',
    familyStatus: 'Family Status',
    interests: 'Interests',
    bioPlaceholder: 'Bio\u2026',
    quotePlaceholder: 'Quote\u2026',
    selectProduct: 'Select a product',
    addSharedExperiences: 'Add Shared Experiences',
    newExperienceGroup: 'New Experience Group',
  },
  product: {
    title: 'Product',
    experiences: 'Experiences',
    personas: 'Personas',
    sharedExperiences: 'Shared Experiences',
    members: 'Members',
    noExperiences: 'No experiences yet. Start by adding one.',
    noPersonas: 'No personas yet.',
    noSharedExperiences: 'No shared experiences yet.',
    addExperience: 'Add Experience',
    addPersona: 'Add Persona',
    addSharedExperience: 'Add Shared Experience',
    newSharedExperience: 'New Shared Experience',
    selectSharedExperience: 'Select a shared experience',
    deleteProduct: 'Delete Product',
    editName: 'Edit Name',
    removeFromProduct: 'Remove from Product',
    addProductToSharedExperience: 'Add Product to Shared Experience',
    newProduct: 'New Product',
    onboardingNameLabel: 'Product Name',
    onboardingNameDescription: 'A digital product is a service or tool accessible on an electronic device (web app, video game, software, etc.)',
    confirmDeleteProduct: 'Are you sure to delete this product?',
    addValueProposition: 'Add Value Proposition',
    addProductTypes: 'Add Product Types',
    addMainFeatures: 'Add Main Features',
    addSharedExperiences: 'Add Shared Experiences',
    addUsefulLinks: 'Add Useful Links',
    editLogo: 'Edit Logo',
    uploadLogo: 'Upload a logo',
    uploadLogoWithText: 'Upload a logo with text',
    types: 'Types',
    valuePropositionPlaceholder: 'User Objective\u2026 User Pain\u2026 User Gain',
    featurePlaceholder: 'Feature\u2026',
    refinePlaceholder: 'Refine\u2026',
    selectPersona: 'Select a persona',
    selectProduct: 'Select a product',
    removePersona: 'Remove Persona',
    confirmRemovePersona: 'Are you sure to remove this persona from the product?',
    newExperienceGroup: 'New Experience Group',
    descriptionPlaceholder: 'Description\u2026',
  },
  sharedExperience: {
    title: 'Shared Experience',
    experiences: 'Experiences',
    personas: 'Personas',
    products: 'Products',
    sharedExperiences: 'Shared Experiences',
    members: 'Members',
    noExperiences: 'No experiences yet. Start by adding one.',
    noPersonas: 'No personas yet.',
    noProducts: 'No products yet.',
    noSharedExperiences: 'No shared experiences yet.',
    noSharedExperiencesSoFar: 'No shared experiences so far',
    addExperience: 'Add Experience',
    addSharedExperience: 'Add Shared Experience',
    newSharedExperience: 'New Shared Experience',
    newSharedExperiences: 'New Shared Experiences',
    selectSharedExperience: 'Select a shared experience',
    deleteSharedExperience: 'Delete Shared Experience',
    editName: 'Edit Name',
    addPersonaToSharedExperience: 'Add Persona to Shared Experience',
    removeFromSharedExperience: 'Remove from Shared Experience',
    addSharedExperiences: 'Add Shared Experiences',
    newExperienceGroup: 'New Experience Group',
    selectProduct: 'Select a product',
    selectPersona: 'Select a persona',
    removeProduct: 'Remove Product',
    removePersona: 'Remove Persona',
    ungroupedExperiences: 'Ungrouped Experiences',
    noExperiencesYet: 'No experiences yet',
    noMembersFound: 'No members found',
    requestToEdit: 'Request to Edit',
  },
  experience: {
    title: 'Experience',
    addExperience: 'Add Experience',
    editExperience: 'Edit Experience',
    deleteExperience: 'Delete Experience',
    noExperienceSoFar: 'No experience so far',
    noInsights: 'No insights yet.',
    untitled: 'Untitled',
    prototype: 'Prototype',
    addPrototypeLink: 'Add Prototype Link',
    editObjective: 'Edit Objective',
    editPrototype: 'Edit Prototype',
    addPrototype: 'Add Prototype',
    newExperience: 'New Experience',
    createNewExperience: 'Create New Experience',
    goToExperience: 'Go to Experience',
    selectExperience: 'Select an experience',
    experiencePlaceholder: 'Action: Make\u2026 Find\u2026 Search\u2026',
    prototypeLinkLabel: 'Prototype Link',
    openPrototype: 'Open Prototype',
    objective: 'Objective',
    objectiveDefinition: 'An experience is a task your user needs to perform.',
    objectiveExample: 'Example: "Write a post". Then specify the product used to complete this task.',
    objectiveLabelTask: 'What task does the user want to complete?',
    objectivePlaceholder: 'Objective',
    leaveGroup: 'Leave the group',
    selectSharedExperience: 'Select a shared experience',
    addSharedExperiences: 'Add Shared Experiences',
    selectProduct: 'Select a product',
    pleaseSelectProduct: 'Please enter at least one product',
    pleaseSelectSharedExperience: 'Please select a shared experience',
    involvedProducts: 'Involved Products',
  },
  group: {
    createGroup: 'Create Group',
    editGroupName: 'Edit Group Name',
    editName: 'Edit name',
    ungroup: 'Ungroup',
    moveToGroup: 'Move to Group',
    moveGroupToAnotherGroup: 'Move Group to Another Group',
    goToGroup: 'Go to Group',
    convertToSharedExperience: 'Convert into shared experience',
    convert: 'Convert',
    convertConfirm: 'Are you sure you want to convert the group',
    convertCannotBeUndone: 'into a shared experience? This action cannot be undone.',
    selectGroup: 'Select a Group',
    pleaseSelectGroup: 'Please select a group',
    groupName: 'Group Name',
    groupNamePlaceholder: 'Group name',
  },
  comment: {
    deleteComment: 'Delete Comment',
    confirmDeleteComment: 'Are you sure to delete this comment?',
    editPlaceholder: 'Edit comment',
    title: 'Comments',
    addPlaceholder: 'Add a comment',
    action: 'Comment',
    one: 'Comment',
    other: 'Comments',
  },
  insight: {
    insights: 'Insights',
    insightType: 'Insight Type',
    insight: 'Insight',
    onboardingNameDescription: 'A UX insight is an important understanding about users that helps to improve a product.',
    importance: 'Importance',
    highest: 'Highest',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    lowest: 'Lowest',
    improvementFeedback: 'Improvement Feedback',
    positiveFeedback: 'Positive Feedback',
    negativeFeedback: 'Negative Feedback',
    behavior: 'Behavior',
    motivation: 'Motivation',
    addImprovementFeedback: 'Add Improvement Feedback',
    addPositiveFeedback: 'Add Positive Feedback',
    addNegativeFeedback: 'Add Negative Feedback',
    addBehavior: 'Add Behavior',
    addMotivation: 'Add Motivation',
    current: 'Current',
    outdated: 'Outdated',
    noInsightSoFar: 'No Insight so far',
    noOutdatedInsight: 'No Outdated Insight',
    setAsOutdated: 'Set as Outdated',
    setAsCurrent: 'Set as Current',
    insightSetAsOutdated: 'Insight set as Outdated',
    insightSetAsCurrent: 'Insight Unarchived',
    insightDeleted: 'Insight Deleted',
    moveToStart: 'Move to start of the list',
    moveToEnd: 'Move to end of the list',
    addImage: 'Add Image',
    editImages: 'Edit Images',
    addQuote: 'Add Quote',
    editQuotes: 'Edit Quotes',
    quotes: 'Quotes',
    moveToExperience: 'Move to Experience',
    confirmDeleteInsight: 'Are you sure to delete this insight?',
    involvedPersona: 'Involved Persona',
    involvedProducts: 'Involved Products',
    selectExperience: 'Select an Experience',
    noImageSoFar: 'No Image so far',
    quotePlaceholder: 'Quote',
    fact: 'Fact',
    assumption: 'Assumption',
    assumptionAbbrev: 'Assum.',
    setAsFact: 'Set as Fact',
    setAsAssumption: 'Set as Assumption',
    moreOptions: 'More Options',
    appliesToAllPersona: 'Applies to all persona of this experience',
    appliesToAllProducts: 'Applies to all products of this experience',
    all: 'All',
    or: 'OR',
  },
  members: {
    members: 'Members',
    generalAccess: 'General Access',
    editionRequested: 'Edition Requested',
    editionRequestPending: 'Edition Request Pending',
    requestEdit: 'Request Edit',
    requestWillBeSent: 'A request will be sent to',
    addPeoplePlaceholder: 'Add People by searching or typing email',
    invitedTooltip: 'This user will be added after signing up',
    subscriptionUpgraded: 'Your subscription is upgraded',
    loadFailed: 'Failed to load members data',
    editRequestSent: 'Edit request sent successfully',
    editRequestFailed: 'Failed to send edit request',
  },
  organisation: {
    inviteNewMember: 'Invite New Member',
    invitationSent: 'Invitation successfully sent',
    invitationFailed: 'Sorry, for some reasons the invitation wasn\'t sent.',
    howToAddMembers: 'How to add new members?',
    howToAddMembersDesc: 'New users will need to sign in with an email matching one of the domains listed below. They will then be automatically added to your organization.',
    howToInviteMembers: 'How to invite new members?',
    howToInviteMembersDesc: 'By clicking on "send email", an invitation email will be sent to the address you entered. The new member will then need to sign up and will be automatically added to your organization.',
    domains: 'Domains',
    domainPlaceholder: 'domain',
    upcomingInvoice: 'Upcoming Invoice',
    invoiceTooltip: 'Includes previous month pro rata if new users added.',
    editLogo: 'Edit Logo',
    upgradeToEnterprise: 'Upgrade to Enterprise Plan',
  },
  feedback: {
    thankYou: 'Thank you for sharing your feedback',
    feedbackType: 'Feedback Type',
    description: 'Description',
  },
  payment: {
    payments: 'Payments',
    success: 'Success',
    fail: 'Fail',
    seeInvoice: 'See Invoice',
    anyProblem: 'Any Problem?',
    contactSupport: 'Contact Support',
    subscriptionCanceled: 'Your subscription was canceled.',
    contactSupportQuestion: 'If you have any questions, please contact support',
    thankYouSubscription: 'Thank you for your subscription!',
    paymentSuccessful: 'Your payment was successful.',
    goHome: 'Go Home',
  },
  notFound: {
    title: '404 - Page Not Found',
  },
  recents: {
    noRecents: 'No recents',
  },
  subscription: {
    plan: 'Plan',
    free: 'Free',
    pro: 'Pro',
    enterprise: 'Enterprise',
    upgrade: 'Upgrade',
    currentPlan: 'Current Plan',
    perMonth: '/month',
    perUserMonth: '/user/month',
    managePlan: 'Manage plan',
    choosePlan: 'Choose a plan',
    basic: 'Basic',
    includes: 'Includes: ',
    unlimitedProducts: 'Unlimited Products',
    unlimitedPersonas: 'Unlimited Personas',
    unlimitedExperiences: 'Unlimited Experiences',
    sharingFeatures: 'Sharing and collaboration features',
    orgAlreadyExists: 'An organisation with your email domain already exists',
    libraryAccess: 'Library of Personas and Products accessible to any collaborators',
    commonBilling: 'Common Billing',
    joinedOrganisation: 'You joined the organisation',
    join: 'Join',
    cancelSubscription: 'Cancel Subscription',
    cancelConfirm: 'Are you sure you want to cancel your subscription? This takes effect immediately and you\'ll lose access to all premium features.',
    typeCancelToConfirm: 'Please type "cancel subscription" to confirm.',
    subscriptionCanceled: 'Your subscription has been canceled',
    approveEditionRequest: 'Approve Edition Request',
    declineEditionRequest: 'Decline Edition Request',
  },
  maintenance: {
    message: 'We\'re currently performing maintenance. The service will be back shortly. Thank you for your patience.',
  },
  languages: {
    en: 'English',
    fr: 'French',
  },
};

export default en;
